import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button } from '@mui/material';
import ExchangeIcon, { EXCHANGE_TOOLBAR_ICON_SIZE, exchangeToolbarIconBtnSx } from '../Exchanges/ExcangeIcon';

const CAP_TABS = [
  { key: 'LgCap', label: 'LgCap' },
  { key: 'MidCap', label: 'MidCap' },
  { key: 'LowCap', label: 'LowCap' },
  { key: 'McrCap', label: 'McrCap' },
];

const isCapFilterActive = (key, min, max) => {
  switch (key) {
    case 'LgCap':
      return min === 1000000000 && max == null;
    case 'MidCap':
      return min === 250000000 && max === 1000000000;
    case 'LowCap':
      return min === 50000000 && max === 250000000;
    case 'McrCap':
      return max === 50000000 && min == null;
    default:
      return false;
  }
};

const capTabButtonSx = (selected) => ({
  flex: 1,
  borderRadius: '999px',
  py: { xs: 0.75, sm: 1 },
  px: { xs: 0.5, sm: 1.25 },
  minWidth: 0,
  fontWeight: 700,
  fontSize: { xs: 11, sm: 13 },
  letterSpacing: 0.4,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  transition: 'all 0.2s ease',
  ...(selected
    ? {
        bgcolor: '#95F205',
        color: '#000',
        boxShadow: '0 2px 10px rgba(149, 242, 5, 0.4)',
        '&:hover': { bgcolor: '#a8ff0a' },
      }
    : {
        bgcolor: 'transparent',
        color: 'rgba(255,255,255,0.55)',
        '&:hover': {
          bgcolor: 'rgba(255,255,255,0.06)',
          color: 'rgba(255,255,255,0.85)',
        },
      }),
});

export const CoinTable = ({ headers, apiData, rows, setPage, page, SetRowIndex, marginBottom = 5, setCurrentExchanges, currentExchanges, min, max, onCapFilterChange, total }) => {
 

  const counts=React.useMemo(()=>{
    let counts={LgCap:0,MidCap:0,LowCap:0,McrCap:0}
    apiData.map((obj)=>{
      if(!obj.rate && !obj.price)return;
      if(obj.cap>=1000000000){
        counts.LgCap++
      }else if(obj.cap<=1000000000 && obj.cap>=250000000){
        counts.MidCap++
      }else if(obj.cap<=250000000 && obj.cap>=50000000){
        counts.LowCap++
      }else if(obj.cap<=50000000){
        counts.McrCap++
      }
    })
    return  counts
  },[apiData])

  return (
    <>
      <Box sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: 1.5,
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', lg: 'center' },
        mt: 1,
        px: 1,
      }}>
        <Box
          role="tablist"
          aria-label="Market cap filters"
          sx={{
            display: 'flex',
            bgcolor: 'rgba(0,0,0,0.35)',
            border: '1px solid rgba(255,255,255,0.25)',
            borderRadius: '999px',
            p: '4px',
            width: { xs: '100%', lg: 'auto' },
            maxWidth: '100%',
            flex: { lg: '0 1 auto' },
          }}
        >
          {CAP_TABS.map(({ key, label }) => {
            const selected = isCapFilterActive(key, min, max);
            return (
              <Button
                key={key}
                role="tab"
                aria-selected={selected}
                disableElevation
                onClick={() => {
                  setPage(0);
                  onCapFilterChange(key);
                }}
                sx={capTabButtonSx(selected)}
              >
                {label} ({counts[key]})
              </Button>
            );
          })}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', justifyContent: { xs: 'center', lg: 'flex-end' } }}>
          {['Coinbase','Binance','KuCoin','MexC', 'Kraken', 'OKX','ByBit','BitMart', 'Bitget' ].map((name) => {
            const isActive = name === currentExchanges;
            return (
              <Box
                key={name}
                component="button"
                type="button"
                aria-pressed={isActive}
                onClick={(event) => {
                  setPage(0);
                  setCurrentExchanges((prev) => (prev === name ? '' : name));
                  event.currentTarget.blur();
                }}
                sx={exchangeToolbarIconBtnSx(isActive)}
                title={isActive ? `Clear ${name} filter` : `Filter by ${name}`}
              >
                <ExchangeIcon compact size={EXCHANGE_TOOLBAR_ICON_SIZE} isLink={false} name={name} />
              </Box>
            );
          })}
        </Box>
      </Box>
      <TableContainer elevation={0} sx={{ bgcolor: 'primary.light', color: 'common.white', marginTop: 1, marginBottom: marginBottom, height: '90vh' }} component={Paper}>
        <Table stickyHeader sx={{ minWidth: 650 }} className='all-coin-table' aria-label="simple table">
          <TableHead sx={{ bgcolor: 'primary.light' }}>
            <TableRow>
              {headers.map(obj => obj.name)}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
               classes='coin-tr'
                key={row[0].symbol}
                sx={{'td': { border: 0 ,padding:"2px"}}}
               
              >
                {row.map((data, index) => <TableCell sx={{ px: 0, color: 'common.white', bgcolor: 'primary.dark', ...data.sx }} align="center">{data.element}</TableCell>)}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>

  );
}


CoinTable.defaultProps = {
  headers: [
    { name: 'Rank', hidden: true },
    { name: '', hidden: true },
    { name: '', hidden: true },
    { name: 'XGain', hidden: true },
    { name: 'Qty', hidden: true },
    { name: 'Price', hidden: true },
    { name: 'AvgBuy', hidden: true },
    { name: 'Invested', hidden: true },
    { name: 'Action', hidden: true },
  ],
  rows: []
}
